import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const Content = styled.div<{ $headerHeight: number }>`
  width: 100%;
  min-height: 0;
  padding-top: ${(props) => props.$headerHeight}px;
  transition: padding-top 0.2s ease;
`;
